import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/unified-career-academy/appEnv';

export default appStarterFactory(appEnv);
